<template>
  <div class="cog-sidenav">
    <div class="cog-sidenav__brand">
      <div class="brand-mark">C</div>
      <div v-if="!collapsed" class="brand-copy">
        <div class="brand-title">COG主播平台后台管理系统</div>
        <div class="brand-subtitle">主播可信资产综合服务平台</div>
      </div>
    </div>

    <el-menu
      :default-active="activeMenu"
      :collapse="collapsed"
      :default-openeds="defaultOpeneds"
      collapse-transition
      router
      unique-opened
      class="cog-sidenav__menu"
      background-color="transparent"
      text-color="#cbd5e1"
      active-text-color="#ffffff">
      <template v-for="menu in allmenu">
        <div v-if="!collapsed && menu.group" :key="menu.group" class="cog-sidenav__group">{{ menu.group }}</div>
        <el-submenu v-if="menu.children && menu.children.length" :key="menu.index" :index="menu.index">
          <template slot="title">
            <i :class="menu.icon"></i>
            <span>{{ menu.label }}</span>
          </template>
          <el-menu-item v-for="child in menu.children" :key="child.path" :index="child.path">
            <i :class="child.icon"></i>
            <span slot="title">{{ child.label }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-else :key="menu.path" :index="menu.path">
          <i :class="menu.icon"></i>
          <span slot="title">{{ menu.label }}</span>
        </el-menu-item>
      </template>
    </el-menu>

    <div class="cog-sidenav__footer">
      <div class="admin-avatar">管</div>
      <div v-if="!collapsed" class="admin-copy">
        <div class="admin-name">{{ adminName }}</div>
        <div class="admin-role">{{ adminRole }}</div>
      </div>
    </div>

    <el-button class="tc" type="danger"  size="small" @click="exit">退出登录</el-button>
  </div>
</template>

<script>
import { loginout } from '../api/userMG'

export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      user: {},
      defaultOpeneds: ['home', 'applications'],
      allmenu: [
        {
          // group: '总览',
          path: '/dashboard',
          label: '数据看板',
          icon: 'el-icon-menu'
        },
        {
          // group: '首页管理',
          index: 'home',
          label: '首页管理',
          icon: 'el-icon-house',
          children: [
            { path: '/home/banner', label: 'Banner管理', icon: 'el-icon-picture' },
            { path: '/home/featured', label: '推荐主播管理', icon: 'el-icon-star-on' },
            { path: '/home/policies', label: '扶持政策管理', icon: 'el-icon-document' }
          ]
        },
        {
          // group: '用户中心',
          path: '/system/user',
          label: '用户管理',
          icon: 'el-icon-user'
        },
        {
          path: '/anchors',
          label: '主播管理',
          icon: 'el-icon-service'
        },
        {
          index: 'applications',
          label: '评估申请管理',
          icon: 'el-icon-tickets',
          children: [
            { path: '/applications/business', label: '商业合作申请', icon: 'el-icon-suitcase' },
            { path: '/applications/evaluation', label: '资产评估申请', icon: 'el-icon-data-analysis' }
          ]
        }
      ]
    }
  },
  computed: {
    activeMenu() {
      const path = this.$route.path || ''
      if (path.indexOf('/applications/business/') === 0) {
        return '/applications/business'
      }
      if (path.indexOf('/applications/evaluation/') === 0) {
        return '/applications/evaluation'
      }
      return path
    },
    adminName() {
      if (this.user && this.user.username) {
        return this.user.username
      }
      return '系统管理员'
    },
    adminRole() {
      return this.user && this.user.is_superuser ? '超级管理员' : '管理员账号'
    }
  },
  created() {
    this.loadUser()
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },
  methods: {
    loadUser() {
      const cachedUser = localStorage.getItem('userInfo')

      if (!cachedUser) {
        this.user = {}
        return
      }

      try {
        this.user = JSON.parse(cachedUser) || {}
      } catch (error) {
        this.user = {}
      }
    },
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const finishLogout = () => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }

          loginout()
            .then(finishLogout)
            .catch(finishLogout)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
  }
}
</script>

<style>
  .tc{
        margin-top: 10px;
        padding: 8px 12px;
        width: 100%;
        border-radius: 6px;
        font-size: 0.8rem;
        color: #ef4444;
        background: rgba(239, 68, 68, 0.1);
        border: none;
        cursor: pointer;
        transition: 0.2s cubic-bezier(0.4, 0),
  }
.cog-sidenav {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 12px;
  background: var(--cog-sidebar);
  color: #fff;
}

.cog-sidenav__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 8px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-mark,
.admin-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: linear-gradient(135deg, var(--cog-primary), var(--cog-accent));
}

.brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 800;
}

.brand-title {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.brand-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.cog-sidenav__menu {
  flex: 1;
  border: none;
  margin-top: 14px;
}

.cog-sidenav__group {
  padding: 14px 12px 8px;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.34);
}

.cog-sidenav__menu .el-menu,
.cog-sidenav__menu .el-submenu__title,
.cog-sidenav__menu .el-menu-item {
  background: transparent !important;
}

.cog-sidenav__menu .el-submenu__title,
.cog-sidenav__menu .el-menu-item {
  height: 44px;
  line-height: 44px;
  border-radius: 10px;
  margin-bottom: 4px;
}

.cog-sidenav__menu .el-submenu__title i,
.cog-sidenav__menu .el-menu-item i {
  color: inherit;
}

.cog-sidenav__menu .el-menu-item:hover,
.cog-sidenav__menu .el-submenu__title:hover {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.06) !important;
}

.cog-sidenav__menu .el-menu-item.is-active {
  color: #fff !important;
  background: rgba(79, 70, 229, 0.3) !important;
}

.cog-sidenav__menu .el-submenu .el-menu-item {
  min-width: 0;
  padding-left: 50px !important;
  font-size: 13px;
}

.cog-sidenav__menu.el-menu--collapse .el-submenu .el-menu-item,
.cog-sidenav__menu.el-menu--collapse .el-menu-item {
  padding-left: 20px !important;
}

.cog-sidenav__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 8px 2px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.admin-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
}

.admin-name {
  font-size: 13px;
  color: #fff;
}

.admin-role {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue